import { RECONNECT_BASE_DELAY, RECONNECT_MAX_DELAY } from '../constants';

/**
 * Calculate the reconnect delay (ms) for a given attempt using exponential
 * backoff capped at {@link RECONNECT_MAX_DELAY}, plus 0–1s of jitter to avoid
 * thundering-herd reconnection.
 */
export const calculateReconnectDelay = (attempt: number): number => {
  const exponentialDelay = Math.min(RECONNECT_BASE_DELAY * Math.pow(2, attempt), RECONNECT_MAX_DELAY);
  const jitter = Math.random() * 1000; // 0-1 second jitter
  return exponentialDelay + jitter;
};
